// extracted by mini-css-extract-plugin
export default {"container":"mic_2RP_8","form":"mic_for_1c2Ty","button":"mic_but_AMcqf"};